import { render, staticRenderFns } from "./h5FAQ.vue?vue&type=template&id=1bc1451d&"
import script from "./h5FAQ.vue?vue&type=script&lang=js&"
export * from "./h5FAQ.vue?vue&type=script&lang=js&"
import style0 from "./h5FAQ.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports